/**
 * Branded preview placeholder shown instead of Gutenberg's "No Preview".
 *
 * Displays the Havenlytics logo, the block title and a short description so a
 * block that has not yet produced a preview still looks like an official
 * Havenlytics feature.
 *
 * @package
 * @since   3.5.0
 */

import { __ } from '@wordpress/i18n';

import HvnlyIcon from './icon';

/**
 * @param {Object} props
 * @param {string} props.title       Block title.
 * @param {string} props.description Short block description.
 * @return {Element} Placeholder element.
 */
export default function HvnlyPlaceholder( { title, description } ) {
	return (
		<div className="hvnly-block-placeholder">
			<span className="hvnly-block-placeholder__logo">{ HvnlyIcon }</span>
			<span className="hvnly-block-placeholder__title">
				{ title || __( 'Havenlytics block', 'havenlytics' ) }
			</span>
			<span className="hvnly-block-placeholder__desc">
				{ description ||
					__(
						'Preview will appear after configuring the block.',
						'havenlytics'
					) }
			</span>
			<span className="hvnly-block-placeholder__hint">
				{ __(
					'Configure block settings in the sidebar.',
					'havenlytics'
				) }
			</span>
		</div>
	);
}
